import { Injectable } from '@angular/core';
import { ToDo } from '../interface/todo.interface';
import { todos } from '../interface/todo-data';

@Injectable({
  providedIn: 'root'
})
export class TodoService {
  public todos: ToDo[] = todos;

  public getTodos(): ToDo[] {
    return this.todos;
  }
}
